import { render, staticRenderFns } from "./ProductsFirstSplitDocumentComplianceLayout.vue?vue&type=template&id=43a61b3b&scoped=true&"
import script from "./ProductsFirstSplitDocumentComplianceLayout.vue?vue&type=script&lang=js&"
export * from "./ProductsFirstSplitDocumentComplianceLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFirstSplitDocumentComplianceLayout.vue?vue&type=style&index=0&id=43a61b3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a61b3b",
  null
  
)

export default component.exports